import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMyTodoSummary } from "../../api/papers";
import WidgetCard from "./WidgetCard"; // 위젯 카드 컴포넌트

export default function TodoWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  const LABEL = {
    SCAR: "안전 시정 조치 요구서 (SCAR)",
    FCR: "설계변경요청(FCR)",
    FCN: "설계변경통보(FCN)",
    DCN: "설계변경도면(DCN)",
    NC: "부적합보고서(NCR)",
    CA: "시정조치서(CAR)",
    ORDER: "작업지시서",
    QC: "검수 체크리스트",
    CK: "검수 결과통보",
  };

  const ROUTE = {
    SCAR: `/project/${projectId}/safety/board/scar`,
    FCR: `/project/${projectId}/design/list/fcr`,
    FCN: `/project/${projectId}/design/list/fcn`,
    DCN: `/project/${projectId}/design/list/dcn`,
    NC: `/project/${projectId}/quality/list/ncr`,
    CA: `/project/${projectId}/quality/list/ncr`,
    ORDER: `/project/${projectId}/const/order`,
    QC: `/project/${projectId}/material/list/qc`,
    CK: `/project/${projectId}/material/list/ck`,
  };

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getMyTodoSummary();
        setData(res || {});
      } catch (err) {
        console.error("담당자 To-do 불러오기 실패:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
    console.log(data);
  }, [projectId]);

  if (loading)
    return (
      <WidgetCard title="내 업무(To-do)">
        <div className="text-sm text-gray-500">작업 불러오는 중...</div>
      </WidgetCard>
    );

  if (!data || !data.summary)
    return (
      <WidgetCard title="내 업무(To-do)">
        <div className="text-sm text-gray-500">
          할 일 정보를 가져올 수 없습니다.
        </div>
      </WidgetCard>
    );

  const summary = data.summary || {};

  return (
    <WidgetCard
      title="내 업무(To-do)"
      linkText="전체보기"
      onLinkClick={() => navigate(`/project/${projectId}/tasks/mytodo`)}
    >
      <div className="space-y-1">
        {Object.entries(summary).map(([type, count]) => {
          const key = type.toUpperCase();
          const label = LABEL[key] || key;
          const route = ROUTE[key];

          return (
            <div
              key={key}
              onClick={() => route && navigate(route)}
              className="flex justify-between items-center px-2 py-1 cursor-pointer hover:bg-gray-50 rounded-md"
            >
              <span className="text-sm text-gray-700">{label}</span>
              <span className="text-sm font-bold text-blue-600">{count}건</span>
            </div>
          );
        })}
      </div>
    </WidgetCard>
  );
}
